import { render, staticRenderFns } from "./douyinVideo.vue?vue&type=template&id=a10ff980"
import script from "./douyinVideo.vue?vue&type=script&lang=js"
export * from "./douyinVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports